<template>
<div>
    <div class="card" :key="setupStaffKey">
        <div class="card-body p-5">
            <div class="accordion accordion-clean" role="tablist">
                <b-card no-body>
                    <b-card-header header-tag="header" class="border-bottom" role="tab">
                        <a class="card-title" block v-b-toggle.accAddStaff>{{$t('header.add')}}{{$t('subMenu.salon_setting_staff')}} 
                            <span class="ml-auto">
                                <span class="collapsed-reveal">
                                    <i class="fal fa-chevron-up fs-xl"></i>
                                </span>
                                <span class="collapsed-hidden">
                                    <i class="fal fa-chevron-down fs-xl"></i>
                                </span>
                            </span>
                        </a>
                    </b-card-header>
                    <b-collapse id="accAddStaff" accordion="accordion" role="tabpanel">
                        <b-card-body class="card-body pt-3">
                            <form @submit.prevent="addStaff">
                                <div class="form-group">
                                    <label class="form-label">{{$t('label.name')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-user"></i>
                                            </span>
                                        </div>
                                        <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.name')" v-model="name" required="">
                                    </div>
                                </div>
                                <div class="form-group mb-0">
                                    <label class="form-label">{{$t('label.contact')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-phone-alt"></i>
                                            </span>
                                        </div>
                                        <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.contact')" v-model="mobile" required="" @keyup="contactValidation">
                                    </div>
                                    <div id="err" class="error-validation"></div>
                                </div>
                                <div class="help-block fs-xs">
                                    <p class="mb-0">{{$t('message.contact_validation.notes')}}:</p>
                                    <ul>
                                        <li>{{$t('message.contact_validation.my')}} 601x xxx xxxx</li>
                                        <li>{{$t('message.contact_validation.sg')}} 65x xxx xxxx</li>
                                    </ul>
                                </div>
                                <div class="text-left pt-3 mt-3 mb-3">
                                    <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.add')}}</button>
                                </div>
                            </form>
                        </b-card-body>
                    </b-collapse>
                </b-card>
                <b-card no-body >
                    <b-card-header header-tag="header" class=" border-bottom" role="tab">
                        <a class="card-title" block v-b-toggle.accListStaff>{{$t('header.list_of', {'item': $t('subMenu.salon_setting_staff')})}}
                            <span class="ml-auto">
                                <span class="collapsed-reveal">
                                    <i class="fal fa-chevron-up fs-xl"></i>
                                </span>
                                <span class="collapsed-hidden">
                                    <i class="fal fa-chevron-down fs-xl"></i>
                                </span>
                            </span>
                        </a>
                    </b-card-header>
                    <b-collapse id="accListStaff" accordion="accordion" role="tabpanel" visible>
                        <b-card-body class="card-body pt-3">
                            <div class="staff-container mt-3">
                                <div class="dataTables_wrapper dt-bootstrap4">
                                    <div class="row">
                                        <div class="col-sm-12 overflow-auto">
                                            <b-table v-if="staffItems.length != 0" small striped hover bordered :fields="fields" :items="staffItems" responsive>
                                                <template #cell(index)="data">
                                                    {{ data.index + 1 }}
                                                </template>
                                                <template #cell(online)="data">
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" class="custom-control-input" :id="'cbx_' + data.item.staffID" v-model="hasOnline[data.item.staffID]">
                                                        <label class="custom-control-label" :for="'cbx_' + data.item.staffID"></label>
                                                    </div>
                                                </template>
                                            </b-table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
            <div class="text-left border-top pt-5">
                <button type="button" class="btn border-0 btn-dark btn-padding waves-effect waves-themed mr-3" @click="returnPreviousStep">{{$t('button_link.prev')}}</button>
                <button type="button" class="btn border-0 btn-primary btn-padding waves-effect waves-themed" @click="submitStaff">{{$t('button_link.next')}}</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import cst from './../../../../assets/js/dashboard/table-header'
import {contactValidation} from './../../../../assets/js/dashboard/utilities'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'setupStaff',
    props:{
        outletID: { type: Number },
    },
    computed:{
        hasOnline(){
            var ret = {};
            for(var i=0; i<this.staffItems.length; i++){
                ret[this.staffItems[i].staffID] = this.staffItems[i].show.online == 1 ? true : false;
            }
            return ret;
        },
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "name", label: this.$i18n.t('table.header.name'), thClass: 'thead-themed align-middle', tdClass: 'align-middle',sortable: true},
                { key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "online", label: this.$i18n.t('table.header.online'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
            ]
        },
    },
    data(){
        return{
            step: 2,
            setupStaffKey: 0,
            name: "", mobile: "",
            tblHeaders: cst.staffTblHeaders,
            staffItems: [],
            isError: false, isModalShow: false, message: "",
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.getStaffItems();
                this.setupStaffKey += 1;
            }
            this.$parent.$parent.isModalShow = false
            
        },
        contactValidation(){
            var err = contactValidation(this.mobile);
            document.getElementById('err').innerHTML = err == null ? null : this.$i18n.t('message.contact_validation.phone_number', {
                'error':  this.$i18n.t(`message.contact_validation.error.${err}`)
            })
        },
        addStaff(){
            var data = {
                name: this.name,
                mobile: this.mobile,
                show: {
                    online: 1
                }
            }
            const url = this.$api.OUTLET +  "/" + this.outletID + this.$api.STAFF
            let $vm = this
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var retData = response.data[0];
                    var message =  $vm.$i18n.t('subMenu.salon_setting_staff') + "'" + retData.name + "'" + $vm.$i18n.t('message.success.add')
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        returnPreviousStep(){
            this.$emit('returnPreviousStep', this.step);
        },
        submitStaff(){
            var results = [];
            for(var i=0; i<this.staffItems.length; i++){
                var isOnline = this.hasOnline[this.staffItems[i].staffID] ? 1 : 0;
                var objShow = {online: isOnline}
                results.push({staffID: this.staffItems[i].staffID, show: objShow})
            }
            var data = {staffs: results};

            const url = this.$api.OUTLET +  "/" + this.outletID + this.$api.STAFF + this.$api.UPDATE
            let $vm = this
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    this.$emit('submitStaff', this.step, {});
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        getStaffItems(){
            let $vm = this
            const url = this.$api.OUTLET + "/" + this.outletID + this.$api.STAFF

            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then(function(response) {
                $vm.staffItems = response.data.staff;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
        }
    },mounted(){
        let $vm = this
        $vm.getStaffItems()
    }
}
</script>
<style scoped>
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
.staff-container{
    max-height: 65vh;
    overflow-x: hidden;
    overflow-y: auto;
}
.show{
    display: block;
}
</style>